module.exports = __webpack_public_path__ + "static/media/close_icon.a4e60a7c.svg";